function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "meetingsTitle"
}, "meetings");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "MP_for_a_Week_Assets",
  transform: "translate(-750.000000, -1064.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Detailed_Icon_Meetings",
  transform: "translate(750.000000, 1064.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-22",
  x: 0,
  y: 0,
  width: 180,
  height: 180
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-1",
  fill: "#5F5984",
  points: "40.2718 139.3717 139.3789 139.3717 139.3789 50.8828 40.2718 50.8828"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(40.000000, 40.209250)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M63.97335,49.66245 L78.15195,49.66245 L78.15195,35.48385 L63.97335,35.48385 L63.97335,49.66245 Z M63.97335,70.85655 L78.15195,70.85655 L78.15195,56.6775 L63.97335,56.6775 L63.97335,70.85655 Z M42.7815,49.66245 L56.9601,49.66245 L56.9601,35.48385 L42.7815,35.48385 L42.7815,49.66245 Z M42.7815,70.85655 L56.9601,70.85655 L56.9601,56.6775 L42.7815,56.6775 L42.7815,70.85655 Z M42.7815,92.0934 L56.9601,92.0934 L56.9601,77.9148 L42.7815,77.9148 L42.7815,92.0934 Z M21.49875,70.85655 L35.67735,70.85655 L35.67735,56.6775 L21.49875,56.6775 L21.49875,70.85655 Z M21.49875,92.0934 L35.67735,92.0934 L35.67735,77.9148 L21.49875,77.9148 L21.49875,92.0934 Z M83.10555,10.674 L83.10555,16.0722 C83.10555,22.7124 77.7033,28.11465 71.06265,28.11465 C64.42245,28.11465 59.01975,22.7124 59.01975,16.0722 L59.01975,10.674 L40.63095,10.674 L40.63095,16.0722 C40.63095,22.7124 35.2287,28.11465 28.58805,28.11465 C21.94785,28.11465 16.5456,22.7124 16.5456,16.0722 L16.5456,10.674 L0.2718,10.674 L0.2718,99.16245 L62.0109,99.16245 C70.92,99.16245 78.14205,91.9404 78.14205,83.03175 L78.14205,77.8716 L83.24865,77.8716 C92.1573,77.8716 99.3789,70.64955 99.3789,61.7409 L99.3789,10.674 L83.10555,10.674 Z",
  id: "Fill-2",
  fill: "#D2CFDD"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-4",
  fill: "#4F4978",
  points: "0.2718 28.494 99.3789 28.494 99.3789 10.67355 0.2718 10.67355"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.06274,21.31911 L71.06274,21.31911 C73.96029,21.31911 76.30974,18.96966 76.30974,16.07211 L76.30974,0.06291 L65.81574,0.06291 L65.81574,16.07211 C65.81574,18.96966 68.16519,21.31911 71.06274,21.31911",
  id: "Fill-5",
  fill: "#AAA3BD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.58805,21.31911 C31.4856,21.31911 33.83505,18.96966 33.83505,16.07211 L33.83505,0.06291 L23.34105,0.06291 L23.34105,16.07211 C23.34105,18.96966 25.6905,21.31911 28.58805,21.31911",
  id: "Fill-6",
  fill: "#AAA3BD"
})))));

var SvgDetailedIconMeetings = function SvgDetailedIconMeetings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "180px",
    height: "180px",
    viewBox: "0 0 180 180",
    "aria-labelledby": "meetingsTitle",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "meetingsTitle"
  }, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDetailedIconMeetings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/detailed-icon-meetings.30eec0fe.svg";
export { ForwardRef as ReactComponent };